export default {
  ADDRESS1: 'ADDRESS1',
  ADDRESS2: 'ADDRESS2',
  ADDRESS3: 'ADDRESS3',
  CITY: 'CITY',
  CODE: 'CODE',
  COMPANY: 'COMPANY',
  COUNTRYID: 'COUNTRYID',
  CUSTOMER_NUMBER: 'CUSTOMER_NUMBER',
  EMAIL: 'EMAIL',
  FIRSTNAME: 'FIRSTNAME',
  ID: 'ID',
  LABEL: 'LABEL',
  LANGUAGEID: 'LANGUAGEID',
  LASTNAME: 'LASTNAME',
  LATITUDE: 'LATITUDE',
  LIMIT: 'LIMIT',
  LIMITSPENT: 'LIMITSPENT',
  LONGITUDE: 'LONGITUDE',
  POSTAL: 'POSTAL',
  SALUTATION: 'SALUTATION',
  STATE: 'STATE',
  STATUS: 'STATUS',
  TELEFAX: 'TELEFAX',
  TELEPHONE: 'TELEPHONE',
  TITLE: 'TITLE',
  VATID: 'VATID',
  WEBSITE: 'WEBSITE',
  DEFAULT_ADDRESS_ID: 'defaultAddressId',
  USER_FORM_DATA: 'userFormData',
  PARENT_BILLING_ADDRESS: 'parentBillingAddress',
  SUB_USER_TYPE: 'sub_user_type',
}
